<div class="parent-grid" [class.disabled]="!allowEdit">
  <div class="detail-container flex-row">
    @for(infoObj of detailValues; track infoObj){
      <div class="detail-group" [class.disabled]="!allowEdit">
        <h3 class="section-header" [class.disabled]="!allowEdit">{{infoObj.sectionHeader}}</h3>
        @for(detail of infoObj.detailDisplayValues.details; track detail){
          <div class="detail-label-and-value">
            <span class="detail-label" [class.subheader]="detail.isSubheader">{{detail.label}}</span>
            @if(detail.value){
              <span class="detail-value" [class.subheader]="detail.isSubheader">{{detail.value}}</span>
            }
          </div>
        }
      </div>
    }
  </div>
  <div class="notes flex-column">
    <div class="notes-header"> 
      <h3 [class.disabled]="!allowEdit">Notes</h3> @if(allowEdit) {<button mat-icon-button [disabled]="isEditing" class="edit-button" (click)="onStartEditing()"><span class="material-symbols-outlined edit-icon">edit</span></button>}
    </div>
    <div class="notes-input">
      <textarea #notes [disabled]="!isEditing" maxlength="500" [(value)] = "noteValue" [placeholder]="placeholderValue">
      </textarea>
    </div>
    <div class="button-container">
      <button mat-raised-button color="primary" type="button"  class="save-button" [class.invisible]="!isEditing" [disabled]="!isEditing || (notes.value === '')" (click)="onSaveNotes(notes.value)"><span class="save-button-label"><span class="material-symbols-outlined">save</span>Save Note</span></button>
    </div>
  </div>
</div>
